import { ErrorBoundary } from 'react-error-boundary';
import { CookiesProvider } from 'react-cookie';
import { AuthProvider, StoreProvider, LocalStorageProvider, FeatureFlagProvider } from 'providers';
import ErrorScreen from 'views/ErrorScreen';
import GlobalData from 'components/GlobalData';
import ScrollToTop from 'components/ScrollToTop';
import Routes from 'app/Routes';

const App = () => (
  <ErrorBoundary FallbackComponent={ErrorScreen}>
    <FeatureFlagProvider>
      <AuthProvider>
        <StoreProvider>
          <LocalStorageProvider>
            <CookiesProvider>
              <GlobalData />
              <ScrollToTop />
              <Routes />
            </CookiesProvider>
          </LocalStorageProvider>
        </StoreProvider>
      </AuthProvider>
    </FeatureFlagProvider>
  </ErrorBoundary>
);

export default App;
